<mat-card appearance="outlined">
    <mat-card-title [innerText]="'MAIN_APP_DIALOG.DAY_NOTE.title' | translate"></mat-card-title>
    <mat-card-content>
      <span class="row" *ngFor="let element of data" style="display: flex; flex-direction: row; padding-top: 4px; column-gap: 1em; border-bottom: 1px solid rgba(0,0,0, 0.3);">
        <div>{{getDate(element.Day)}}</div>
        <span style="flex:1" [innerText]="element.Note"></span>
      </span>
    </mat-card-content>
    <mat-dialog-actions>
      <button mat-stroked-button class="cancel" (click)="closeDialog()" [innerText]="'MAIN_APP_DIALOG.close' | translate"></button>
    </mat-dialog-actions>
  </mat-card>